// src/types/label.ts

// Desteklediğimiz yazıcı dilleri enum yapısı
export type PrinterLanguage = "ZPL" | "TSPL" | "EPL" | "ESC_POS" | "PDF";

export enum LabelCategory {
  PRODUCT = "PRODUCT",
  SHIPPING = "SHIPPING",
  PICKING = "PICKING",
  PACKING = "PACKING",
  RECEIPT = "RECEIPT",
  WAYBILL = "WAYBILL",
  INVOICE = "INVOICE",
  SHELF = "SHELF",
  WEIGHING = "WEIGHING",
  OTHER = "OTHER"
}
/**
 * Her bir şablonun altına kaydedilen dil ve tenant varyantı
 */
export interface LabelVariant {
    id: string;
    templateId: string;
    tenantId: string | null; // null ise sistem genelidir, dolu ise o firmaya özeldir
    language: PrinterLanguage;
    widthMm?: number | null;  // Etiket fiziksel genişliği (milimetre)
    heightMm?: number | null; // Etiket fiziksel yüksekliği (milimetre)
    content: string;          // Asıl yazıcı komutları/kodları (şablon metni)
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
}

/**
 * Ana Etiket Şablon Modeli (Örn: SHIPPING_LABEL, PRODUCT_BARCODE)
 */
export interface LabelTemplate {
    id: string;
    code: string;        // Benzersiz sistem kodu (Sorgularda bunu kullanacağız)
    name: string;        // Kullanıcının gördüğü isim
    description?: string | null;
    category?: LabelCategory;
    designJson?: string | null;
    createdAt: string;
    updatedAt: string;
    variants?: LabelVariant[]; // Şablona ait farklı dillerdeki tasarımlar
}

/**
 * Yeni bir Etiket Şablonu oluştururken veya meta bilgilerini güncellerken
 * API'ye göndereceğimiz veri paketi (Payload)
 */
export interface LabelTemplatePayload {
    code?: string;       // Yeni oluştururken zorunlu, düzenlerken genellikle gönderilmez/değiştirilmez
    name: string;
    description?: string;
    category?: LabelCategory;
    designJson?: string;
}

/**
 * Editör sayfasında bir dile ait tasarımı kaydederken
 * API'ye göndereceğimiz varyant paket (Payload)
 */
export interface LabelVariantPayload {
    templateId: number;
    language: PrinterLanguage;
    widthMm?: number;
    heightMm?: number;
    content: string;
}